
import { Loader2 } from "lucide-react";
import { cn } from "@/lib/utils";

interface LoaderProps {
  size?: number;
  className?: string;
  text?: string;
}

export function Loader({ size = 24, className, text }: LoaderProps) {
  return (
    <div className={cn("flex items-center justify-center gap-2", className)}>
      <Loader2 
        size={size} 
        className="animate-spin text-primary" 
      />
      {text && <span className="text-sm text-muted-foreground">{text}</span>}
    </div>
  );
}
